import ToggleButton from 'components/Shared/Forms/ToggleButton'
import Icon from 'components/Shared/Icon'
import { handleAppPublishing, selectAppPublished } from 'ducks/apps'
import { useFunnelTracking } from 'hooks/useFunnelTracking'
import { useDispatch, useSelector } from 'react-redux'
import { requestAppBuilds } from 'utils/io'
import {
  showModal as showEditorModal,
  UNPUBLISH_APP_MODAL,
} from 'ducks/editor/modals'
import { getCurrentOrganization } from 'ducks/organizations'

const PublishPanelHeader = ({
  appId,
  setShowPublishingAddonModal,
  showPublishToggle,
}) => {
  const dispatch = useDispatch()
  const { trackPublishedApp, trackUnpublishedApp } = useFunnelTracking()

  const isPublished = useSelector(state => selectAppPublished(state, appId))
  const organization = useSelector(getCurrentOrganization)

  const publishApp = async () => {
    try {
      await dispatch(handleAppPublishing(appId, { published: true }))
    } catch (error) {
      setShowPublishingAddonModal(true)
    }

    // Track when app gets published
    if (organization?.id) {
      trackPublishedApp(organization.id)
    }
  }

  const unpublishApp = async () => {
    const { value: shouldUnpublishApp } = await dispatch(
      showEditorModal(UNPUBLISH_APP_MODAL)
    )

    if (shouldUnpublishApp) {
      // set showAdaloAttribution to true for users on free plan
      const webSettings =
        organization?.planType === 'free' ? { showAdaloAttribution: true } : {}

      await dispatch(
        handleAppPublishing(appId, {
          published: false,
          DomainId: null,
          webSettings,
        })
      )

      // Track when app gets unpublished
      if (organization?.id) {
        trackUnpublishedApp(organization.id)
      }
    }
  }

  const handleTogglePublished = async () => {
    if (isPublished) {
      await unpublishApp()
    } else {
      await publishApp()
    }

    requestAppBuilds(appId, 'web', { order: 'DESC' })
  }

  return (
    <div className="left-panel-header">
      <div className="left-panel-header-title">
        <Icon type="done-all" color="green" />
        <h2>Publish</h2>
        {showPublishToggle && (
          <ToggleButton
            value={isPublished}
            onChange={handleTogglePublished}
            disabled={!organization?.active}
          />
        )}
      </div>
      {showPublishToggle && (
        <div className="left-panel-header-subtext">
          <span>
            Any apps that share this database will also be marked as published.
          </span>
        </div>
      )}
    </div>
  )
}

export default PublishPanelHeader
